"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WS_WRTC_SDP_OFFER = exports.WS_WRTC_SDP_ANSWER = exports.WS_WRTC_PC_REQUEST = exports.WS_WRTC_PC_CLOSE = exports.WS_WRTC_ICE_CANDIDATES = exports.WRTC_RECEIVE_FROM_PEER = exports.WRTC_PC_RESET = exports.WRTC_ON_PC_TRACK_ADDED = exports.WRTC_ON_PC_STREAM_CHANGE = exports.WRTC_ON_PC_STREAM = exports.WRTC_ON_PC_STATS = exports.WRTC_ON_PC_SIGNAL = exports.WRTC_ON_PC_ICE_STATE_CHANGE = exports.WRTC_ON_PC_ICE_ERROR = exports.WRTC_ON_PC_ERROR = exports.WRTC_ON_PC_DATA = exports.WRTC_ON_PC_CONNECT = exports.WRTC_ON_PC_CLOSE = exports.WRTC_CONNECTION_STATE_CHANGE = exports.WEBRTC_RECEIVE_CALL = exports.START_CALL_WITH = exports.SET_INPUT_DEVICES_ERROR = exports.REQUEST_LOCAL_STREAM = void 0;
var WRTC_ON_PC_CLOSE = exports.WRTC_ON_PC_CLOSE = 'WRTC_ON_PC_CLOSE';
var WRTC_ON_PC_CONNECT = exports.WRTC_ON_PC_CONNECT = 'WRTC_ON_PC_CONNECT';
var WRTC_ON_PC_DATA = exports.WRTC_ON_PC_DATA = 'WRTC_ON_PC_DATA';
var WRTC_ON_PC_ERROR = exports.WRTC_ON_PC_ERROR = 'WRTC_ON_PC_ERROR';
var WRTC_ON_PC_ICE_STATE_CHANGE = exports.WRTC_ON_PC_ICE_STATE_CHANGE = 'WRTC_ON_PC_ICE_STATE_CHANGE';
var WRTC_ON_PC_ICE_ERROR = exports.WRTC_ON_PC_ICE_ERROR = 'WRTC_ON_PC_ICE_ERROR';
var WRTC_PC_RESET = exports.WRTC_PC_RESET = 'WRTC_PC_RESET';
var WRTC_ON_PC_SIGNAL = exports.WRTC_ON_PC_SIGNAL = 'WRTC_ON_PC_SIGNAL';
var WRTC_ON_PC_STATS = exports.WRTC_ON_PC_STATS = 'WRTC_ON_PC_STATS';
var WRTC_ON_PC_STREAM = exports.WRTC_ON_PC_STREAM = 'WRTC_ON_PC_STREAM';
var WRTC_ON_PC_STREAM_CHANGE = exports.WRTC_ON_PC_STREAM_CHANGE = 'WRTC_ON_PC_STREAM_CHANGE';
var WRTC_ON_PC_TRACK_ADDED = exports.WRTC_ON_PC_TRACK_ADDED = 'WRTC_ON_PC_TRACK_ADDED';
var WRTC_RECEIVE_FROM_PEER = exports.WRTC_RECEIVE_FROM_PEER = 'WRTC_RECEIVE_FROM_PEER';
var WS_WRTC_ICE_CANDIDATES = exports.WS_WRTC_ICE_CANDIDATES = 'WS_WRTC_ICE_CANDIDATES';
var WS_WRTC_PC_CLOSE = exports.WS_WRTC_PC_CLOSE = 'WS_WRTC_PC_CLOSE';
var WS_WRTC_PC_REQUEST = exports.WS_WRTC_PC_REQUEST = 'WS_WRTC_PC_REQUEST';
var WS_WRTC_SDP_ANSWER = exports.WS_WRTC_SDP_ANSWER = 'WS_WRTC_SDP_ANSWER';
var WS_WRTC_SDP_OFFER = exports.WS_WRTC_SDP_OFFER = 'WS_WRTC_SDP_OFFER';
var WRTC_CONNECTION_STATE_CHANGE = exports.WRTC_CONNECTION_STATE_CHANGE = 'WRTC_CONNECTION_STATE_CHANGE';

// SHOULD BE CHECKED AND CLEARED

var REQUEST_LOCAL_STREAM = exports.REQUEST_LOCAL_STREAM = 'REQUEST_LOCAL_STREAM';
var SET_INPUT_DEVICES_ERROR = exports.SET_INPUT_DEVICES_ERROR = 'SET_INPUT_DEVICES_ERROR';
var START_CALL_WITH = exports.START_CALL_WITH = 'START_CALL_WITH';
var WEBRTC_RECEIVE_CALL = exports.WEBRTC_RECEIVE_CALL = 'WEBRTC_RECEIVE_CALL';
///